import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enTimeoff from './locales/en/timeoff.json';
import enEmployees from './locales/en/employees.json';
import enSettings from './locales/en/settings.json';
import enNavigation from './locales/en/navigation.json';
import enHeader from './locales/en/header.json';
import enDocuments from './locales/en/documents.json';
import enTraining from './locales/en/training.json';
import enExpenses from './locales/en/expenses.json';
import enProfile from './locales/en/profile.json';
import enManager from './locales/en/manager.json';
import enPayroll from './locales/en/payroll.json';
import enOnboarding from './locales/en/onboarding.json';
import enHolidays from './locales/en/holidays.json';
import enHelp from './locales/en/help.json';
import enAdmin from './locales/en/admin.json';
import enAutomation from './locales/en/automation.json';
import enBenefits from './locales/en/benefits.json';
import enPerformance from './locales/en/performance.json';
import enWorkforce from './locales/en/workforce.json';
import enConversations from './locales/en/conversations.json';
import enHome from './locales/en/home.json';
import enWebBrowser from './locales/en/webBrowser.json';
import enWork from './locales/en/work.json';
import enEverydayServices from './locales/en/everydayServices.json';
import enBrandAmbassadors from './locales/en/brandAmbassadors.json';

import swCommon from './locales/sw/common.json';
import swAuth from './locales/sw/auth.json';
import swDashboard from './locales/sw/dashboard.json';
import swTimeoff from './locales/sw/timeoff.json';
import swEmployees from './locales/sw/employees.json';
import swSettings from './locales/sw/settings.json';
import swNavigation from './locales/sw/navigation.json';
import swHeader from './locales/sw/header.json';
import swDocuments from './locales/sw/documents.json';
import swTraining from './locales/sw/training.json';
import swExpenses from './locales/sw/expenses.json';
import swProfile from './locales/sw/profile.json';
import swManager from './locales/sw/manager.json';
import swPayroll from './locales/sw/payroll.json';
import swOnboarding from './locales/sw/onboarding.json';
import swHolidays from './locales/sw/holidays.json';
import swHelp from './locales/sw/help.json';
import swAdmin from './locales/sw/admin.json';
import swAutomation from './locales/sw/automation.json';
import swBenefits from './locales/sw/benefits.json';
import swPerformance from './locales/sw/performance.json';
import swWorkforce from './locales/sw/workforce.json';
import swConversations from './locales/sw/conversations.json';
import swHome from './locales/sw/home.json';
import swWebBrowser from './locales/sw/webBrowser.json';
import swWork from './locales/sw/work.json';
import swEverydayServices from './locales/sw/everydayServices.json';
import swBrandAmbassadors from './locales/sw/brandAmbassadors.json';

export const defaultNS = 'common';
export const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    timeoff: enTimeoff,
    employees: enEmployees,
    settings: enSettings,
    navigation: enNavigation,
    header: enHeader,
    documents: enDocuments,
    training: enTraining,
    expenses: enExpenses,
    profile: enProfile,
    manager: enManager,
    payroll: enPayroll,
    onboarding: enOnboarding,
    holidays: enHolidays,
    help: enHelp,
    admin: enAdmin,
    automation: enAutomation,
    benefits: enBenefits,
    performance: enPerformance,
    workforce: enWorkforce,
    conversations: enConversations,
    home: enHome,
    webBrowser: enWebBrowser,
    work: enWork,
    everydayServices: enEverydayServices,
    brandAmbassadors: enBrandAmbassadors,
  },
  sw: {
    common: swCommon,
    auth: swAuth,
    dashboard: swDashboard,
    timeoff: swTimeoff,
    employees: swEmployees,
    settings: swSettings,
    navigation: swNavigation,
    header: swHeader,
    documents: swDocuments,
    training: swTraining,
    expenses: swExpenses,
    profile: swProfile,
    manager: swManager,
    payroll: swPayroll,
    onboarding: swOnboarding,
    holidays: swHolidays,
    help: swHelp,
    admin: swAdmin,
    automation: swAutomation,
    benefits: swBenefits,
    performance: swPerformance,
    workforce: swWorkforce,
    conversations: swConversations,
    home: swHome,
    webBrowser: swWebBrowser,
    work: swWork,
    everydayServices: swEverydayServices,
    brandAmbassadors: swBrandAmbassadors,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS,
    debug: false,
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'preferred-locale',
    },
    
    react: {
      useSuspense: false, // Disable suspense to avoid loading issues
    },
  });

export default i18n;